import { tv } from 'tailwind-variants';

const styles = tv({
    base: `
    iris:mx-(--sem-space-page-margin-sm)
    iris:box-border
    iris:w-full
    iris:md:mx-(--sem-space-page-margin-md)
    iris:lg:mx-(--sem-space-page-margin-lg)
    iris:xl:mx-(--sem-space-page-margin-xl)
  `,
    variants: {
        // Responsive display
        display: {
            initial: "iris:block",
            none: "iris:hidden",
        },
        maxWidth: {
            none: `
        iris:md:mx-0
        iris:lg:mx-0
        iris:xl:mx-0
      `,
            md: "iris:max-w-(--sem-space-page-max-width-md)",
            lg: "iris:max-w-(--sem-space-page-max-width-lg)",
        },
    },
});

export { styles as default };
